import dynamic from "next/dynamic";
import Head from "next/head";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Constants } from "@/schemas/data";
import NavBar from "../NavBar/Navbar";
const PopupForm = dynamic(() => import("../PopupForm/PopupForm"), {
  ssr: false,
});
const Schemas = dynamic(() => import("@/schemas"), { ssr: false });
import usePopupVisibility from "../PopupForm/usePopupVisibility";
const Footer = dynamic(() => import("@/components/Footer/Footer"), {
  ssr: false,
});
const DefaltData = {
  titel:
    "Regenesys: Explore Top Degrees in Business, Law, Finance, Technology and Public Management",
  description:
    "Regenesys: Explore business, law, public management, finance, and technology degree at Regenesys school. Find your perfect programme & enrol today!",
  img: "https://s3-inf-prod-dr-cms.s3.ap-south-1.amazonaws.com/cms/DR_Website_31f627c203.webp",
  keywords: "regenesys",
};

const Layout = (props: any) => {
  const { children, SeoData } = props;
  const router = useRouter();
  const { asPath } = router;

  const pathArray = SeoData?.canonical
    ? SeoData?.canonical
    : asPath.split("/").filter((path) => path);

  // ================meta tags===================
  const title = SeoData?.meta_title ? SeoData?.meta_title : DefaltData?.titel;
  const description = SeoData?.meta_description ?? DefaltData?.description;
  const robots = SeoData?.robots ? SeoData?.robots : "index, follow";
  const keywords = SeoData?.meta_keywords
    ? SeoData?.meta_keywords
    : DefaltData?.keywords;
  // ================og tags===================

  const ogTitle = SeoData?.og_tags?.title
    ? SeoData?.og_tags?.title
    : DefaltData?.titel;
  const ogType = SeoData?.og_tags?.type ? SeoData?.og_tags?.type : "website";
  const ogDescription = SeoData?.og_tags?.description
    ? SeoData?.og_tags?.description
    : DefaltData?.description;
  const ogImg = SeoData?.og_tags?.image?.url
    ? SeoData?.og_tags?.image?.url
    : DefaltData?.img;

  // ================twitter tags===================

  const twitterTitle = SeoData?.twitter_tags?.title
    ? SeoData?.twitter_tags?.title
    : DefaltData?.titel;
  const twitterType = SeoData?.twitter_tags?.type
    ? SeoData?.twitter_tags?.type
    : "summary_large_image";
  const twitterDescription = SeoData?.twitter_tags?.description
    ? SeoData?.twitter_tags?.description
    : DefaltData?.description;
  const twitterImg = SeoData?.twitter_tags?.image?.url
    ? SeoData?.twitter_tags?.image?.url
    : DefaltData?.img;

  const canonicalBaseUrl = (() => {
    const env = process.env.ENV_NAME;
    if (env === "production") {
      return `https://www.regenesys.net/${pathArray ? pathArray : ""}`;
    } else if (env === "uat") {
      return `https://uat-rbs-website.regenesys.net/${
        pathArray ? pathArray : ""
      }`;
    } else {
      return `https://dev-rbs-website.regenesys.net/${
        pathArray ? pathArray : ""
      }`;
    }
  })();

  useEffect(() => {
    const linkElement = document.getElementById("dynamic-url");
    if (linkElement) {
      linkElement.setAttribute("href", canonicalBaseUrl);
    }
  }, [canonicalBaseUrl]);

  const capitalizeText = (text: string) => {
    const cleanedText = text.replace(/[\/-]/g, " ").toLowerCase();

    return cleanedText
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const findBreadcrumbs = (slug: string) => {
    const coursesData =
      props?.commonData?.header?.main_nav_links[0]?.nested_list_links || [];

    // Check if the slug matches a school or program in the API data
    for (const school of coursesData) {
      if (school.url === slug) {
        return [
          { title: "Home", href: "/" },
          { title: "All Academic Programme", href: "/all-academic-programmes" },
          { title: capitalizeText(school.title) },
        ];
      }

      for (const list of school.lists) {
        if (list.url === slug) {
          return [
            { title: "Home", href: "/" },
            {
              title: "All Academic Programme",
              href: "/all-academic-programmes",
            },
            { title: capitalizeText(school.title), href: `/${school.url}` },
            { title: capitalizeText(list.url) },
          ];
        }

        for (const item of list.items) {
          if (item.url === slug) {
            return [
              { title: "Home", href: "/" },
              {
                title: "All Academic Programme",
                href: "/all-academic-programmes",
              },
              { title: capitalizeText(school.title), href: `/${school.url}` },
              { title: capitalizeText(list.url), href: `${list.url}` },
              { title: capitalizeText(item.label) },
            ];
          }
        }
      }

      for (const item of school.links) {
        if (item.url === slug) {
          return [
            { title: "Home", href: "/" },
            {
              title: "All Academic Programme",
              href: "/all-academic-programmes",
            },
            { title: capitalizeText(school.title), href: `/${school.url}` },
            { title: capitalizeText(item.label) },
          ];
        }
      }
    }

    // Fallback for unmatched slugs
    return [{ title: "Home", href: "/" }, { title: capitalizeText(slug) }];
  };

  const pathWithoutQuery = router.asPath.split("?")[0];
  const pathArrays = pathWithoutQuery.split("/").filter(Boolean);
  const breadcrumbData = findBreadcrumbs(
    pathArrays[pathArrays.length - 1] || ""
  );
  const { isPopupVisible, showPopup, hidePopup } = usePopupVisibility();
  const [BroutcherLink, setBroutcherLink] = useState("");
  const [pageSlug, setPageSlug] = useState("");

  useEffect(() => {
    // Extract the page slug from the router
    const slug = router.asPath.split("/").filter(Boolean).join("/");
    setPageSlug(slug || "home"); // Default to "home" if the slug is empty
  }, [router.asPath]);

  const handleBroutcherButtonClick = (broutcherLink?: any) => {
    showPopup();
    setBroutcherLink(broutcherLink);
  };

  const processProgramData = () => {
    if (!Array.isArray(props.CourseData)) {
      console.error(
        "Invalid data structure or missing program brochure list items"
      );
      return [];
    }

    const listItems = props.CourseData;

    const studyModeItem = listItems.find(
      (item: any) => item.title === "Study Mode"
    );
    const durationItem = listItems.find(
      (item: any) => item.title === "Duration"
    );

    const durationDescription = durationItem?.description || "";
    const studyModeDescription = studyModeItem?.description || "";

    const durationNumber =
      parseInt(durationDescription.match(/\d+/)?.[0], 10) || null;

    let studyMode: string | string[] = "";

    // Ensure that studyModeDescription is a valid string before calling .toLowerCase()
    if (
      studyModeDescription &&
      studyModeDescription.toLowerCase().includes("online") &&
      studyModeDescription.toLowerCase().includes("contact")
    ) {
      studyMode = ["online", "onsite"];
    } else if (
      studyModeDescription &&
      studyModeDescription.toLowerCase().includes("online")
    ) {
      studyMode = "online";
    } else if (
      studyModeDescription &&
      studyModeDescription.toLowerCase().includes("contact")
    ) {
      studyMode = "onsite";
    } else if (
      studyModeDescription &&
      studyModeDescription.toLowerCase().includes("blended learning")
    ) {
      studyMode = ["online", "onsite"];
    }

    return {
      duration: durationNumber,
      studyMode,
    };
  };

  // Call the function and store the result
  const SchemaData = processProgramData();

  return (
    <>
      <Head>
        <title>{title}</title>
        {canonicalBaseUrl && (
          <link rel="canonical" href={canonicalBaseUrl} id="dynamic-url" />
        )}

        {description && <meta name="description" content={description} />}
        {keywords && <meta name="keywords" content={keywords} />}
        {process.env.ENV_NAME === "production" && (
          <meta name="robots" content={robots} />
        )}
        {process.env.ENV_NAME !== "production" && (
          <meta name="robots" content="no-index, no-follow" />
        )}
        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="google-site-verification"
          content="IPpxrFOTxWsjCvkuc5oxJmhaWxr677C6rqva7Chs2VA"
        />
        {canonicalBaseUrl && (
          <meta property="og:url" content={canonicalBaseUrl} />
        )}
        {ogType && <meta property="og:type" content={ogType} />}
        {ogTitle && <meta property="og:title" content={ogTitle} />}
        {ogDescription && (
          <meta property="og:description" content={ogDescription} />
        )}
        {ogImg && <meta property="og:image" content={ogImg} />}
        {twitterType && <meta name="twitter:card" content={twitterType} />}
        <meta property="twitter:domain" content="regenesys.net" />
        {canonicalBaseUrl && (
          <meta property="twitter:url" content={canonicalBaseUrl} />
        )}
        {twitterTitle && <meta name="twitter:title" content={twitterTitle} />}
        {twitterDescription && (
          <meta name="twitter:description" content={twitterDescription} />
        )}
        {twitterImg && <meta name="twitter:image" content={twitterImg} />}

        <link rel="canonical" href={canonicalBaseUrl} id="dynamic-url" />
        <link rel="alternate" href={canonicalBaseUrl} hrefLang="en-ng" />
        <link rel="alternate" href={canonicalBaseUrl} hrefLang="en-ke" />
        <link rel="alternate" href={canonicalBaseUrl} hrefLang="en-za" />
        <link rel="alternate" href={canonicalBaseUrl} hrefLang="x-default" />
        <link rel="alternate" href={canonicalBaseUrl} hrefLang="en" />
        <link rel="preconnect" href="https://prod-cdn.regenesys.net/" />
      </Head>

      {props.CourseData && (
        <Schemas
          type={Constants.course}
          data={{
            name: title,
            description: description,
            url: pathArray,
            courseMode: SchemaData,
          }}
        />
      )}
      <Schemas type={Constants.breadCrumb} data={breadcrumbData} />
      {props.schemaFaq && (
        <Schemas type={Constants.faq} data={props.schemaFaq} />
      )}

      {props.pageName === "home" && (
        <>
          <Schemas type={Constants.website} />
          <Schemas type={Constants.home} />
        </>
      )}

      <main id="wrapper">
        {isPopupVisible && (
          <PopupForm
            isVisible={isPopupVisible}
            onClose={hidePopup}
            BroutcherLink={BroutcherLink}
            pageSlug={pageSlug}
          />
        )}

        <NavBar
          handleEnrollButtonClick={showPopup}
          handleBroutcherButtonClick={handleBroutcherButtonClick}
          pageTitle={props.pageTitle}
          data={props?.commonData?.header}
        />

        {children}
        <Footer
          data={props?.commonData?.footer}
          headerData={props?.commonData?.header}
        />
      </main>
    </>
  );
};

export default Layout;
